import ShopTaxedPriceResourceModel from '../../generated/types/model/resource/ShopTaxedPriceResourceModel';

export default class ShopTaxedPriceResourceViewModel extends ShopTaxedPriceResourceModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
